export const TINYMCE_LIST_CONFIG = {
    base_url: '/tinymce',
    outputFormat: 'text',
    suffix: '.min',
    height: 150,
    menubar: false,
    toolbar: false,
    statusbar: false,
    plugins: ['advlist lists link', 'visualblocks', 'paste code help'],
};

export const TINYMCE_EDITOR_CONFIG = {
    base_url: '/tinymce',
    outputFormat: 'text',
    suffix: '.min',
    height: 150,
    menubar: false,
    statusbar: false,
    plugins: ['advlist lists link', 'visualblocks', 'paste code help preview'],
    toolbar:
        'undo redo | fontsizeselect formatselect | bold italic backcolor link | \
         alignleft aligncenter alignright alignjustify | \
         bullist numlist outdent indent | removeformat preview code',
};
